import { formatShortcutKey } from '~/components/component-library/Button/helpers'
import { buttonShortcutVariants } from '~/components/component-library/Button/styles'
import { type ButtonProps } from '~/components/component-library/Button/types'
import { useIsMobileDevice } from '~/utils/devices'
import { cn } from '~/utils/tailwind-utils'

export const ButtonShortcut = ({
  shortcut,
  variant,
  fullWidth,
  size,
}: {
  shortcut: ButtonProps['shortcut']
  variant: ButtonProps['variant']
  fullWidth: ButtonProps['fullWidth']
  size: ButtonProps['size']
}) => {
  // keyboard shortcuts obv don't work on mobile, so don't display them
  if (useIsMobileDevice()) return null

  return (
    <div className={cn(buttonShortcutVariants({ variant, fullWidth, size }))}>
      {formatShortcutKey(shortcut?.key || '')}
    </div>
  )
}

ButtonShortcut.displayName = 'ButtonShortcut'
